<template>
	<v-card class="solid-mesh-transform-panel" color="panel_sub">
		<v-card-text class="pa-2">
			<v-row dense>
				<v-col cols="12">
					<div class="text-caption text-grey">{{ $t("TRANSFORM") }}</div>
				</v-col>
			</v-row>

			<!-- Rotation -->
			<v-row dense class="mt-2">
				<v-col cols="12">
					<div class="text-caption mb-1">{{ $t("ROTATION") }} (degrees)</div>
				</v-col>
				<v-col cols="12">
					<div class="d-flex align-center">
						<span class="mr-2" style="min-width: 20px;">X</span>
						<v-slider v-model="rotation.x" :min="rotationConstraint.min" :max="rotationConstraint.max"
							:step="rotationConstraint.step" density="compact" hide-details
							@update:model-value="(v) => onRotationUpdateForSlide('x', v)" @end="onRotationEnd"></v-slider>
						<v-text-field :model-value="rotationInputs.x" type="number" :step="rotationConstraint.step"
							:min="rotationConstraint.min" :max="rotationConstraint.max" density="compact" hide-details
							variant="outlined" style="max-width: 80px; margin-left: 8px;"
							@update:model-value="(v) => onRotationUpdate('x', String(v))"
							@input="onRotationInput('x', $event)"></v-text-field>
					</div>
				</v-col>
				<v-col cols="12">
					<div class="d-flex align-center">
						<span class="mr-2" style="min-width: 20px;">Y</span>
						<v-slider v-model="rotation.y" :min="rotationConstraint.min" :max="rotationConstraint.max"
							:step="rotationConstraint.step" density="compact" hide-details
							@update:model-value="(v) => onRotationUpdateForSlide('y', v)" @end="onRotationEnd"></v-slider>
						<v-text-field :model-value="rotationInputs.y" type="number" :step="rotationConstraint.step"
							:min="rotationConstraint.min" :max="rotationConstraint.max" density="compact" hide-details
							variant="outlined" style="max-width: 80px; margin-left: 8px;"
							@update:model-value="(v) => onRotationUpdate('y', String(v))"
							@input="onRotationInput('y', $event)"></v-text-field>
					</div>
				</v-col>
				<v-col cols="12">
					<div class="d-flex align-center">
						<span class="mr-2" style="min-width: 20px;">Z</span>
						<v-slider v-model="rotation.z" :min="rotationConstraint.min" :max="rotationConstraint.max"
							:step="rotationConstraint.step" density="compact" hide-details
							@update:model-value="(v) => onRotationUpdateForSlide('z', v)" @end="onRotationEnd"></v-slider>
						<v-text-field :model-value="rotationInputs.z" type="number" :step="rotationConstraint.step"
							:min="rotationConstraint.min" :max="rotationConstraint.max" density="compact" hide-details
							variant="outlined" style="max-width: 80px; margin-left: 8px;"
							@update:model-value="(v) => onRotationUpdate('z', String(v))"
							@input="onRotationInput('z', $event)"></v-text-field>
					</div>
				</v-col>
			</v-row>

			<!-- Scale -->
			<!-- <v-row dense class="mt-2">
				<v-col cols="12">
					<div class="text-caption mb-1">{{ $t("SCALE") }}</div>
				</v-col>
				<v-col cols="12">
					<div class="d-flex align-center">
						<span class="mr-2" style="min-width: 20px;">X</span>
						<v-slider v-model="scale.x" :min="-50" :max="50" :step="0.1" density="compact" hide-details
							@update:model-value="onScaleUpdate" @end="onScaleEnd"></v-slider>
						<v-text-field :model-value="scaleInputs.x" type="number" :max="50" :step="0.1" density="compact"
							hide-details variant="outlined" style="max-width: 80px; margin-left: 8px;"
							@update:model-value="(v) => onScaleInput('x', String(v))"></v-text-field>
					</div>
				</v-col>
				<v-col cols="12">
					<div class="d-flex align-center">
						<span class="mr-2" style="min-width: 20px;">Y</span>
						<v-slider v-model="scale.y" :min="-50" :max="50" :step="0.1" density="compact" hide-details
							@update:model-value="onScaleUpdate" @end="onScaleEnd"></v-slider>
						<v-text-field :model-value="scaleInputs.y" type="number" :max="50" :step="0.1" density="compact"
							hide-details variant="outlined" style="max-width: 80px; margin-left: 8px;"
							@update:model-value="(v) => onScaleInput('y', String(v))"></v-text-field>
					</div>
				</v-col>
				<v-col cols="12">
					<div class="d-flex align-center">
						<span class="mr-2" style="min-width: 20px;">Z</span>
						<v-slider v-model="scale.z" :min="-50" :max="50" :step="0.1" density="compact" hide-details
							@update:model-value="onScaleUpdate" @end="onScaleEnd"></v-slider>
						<v-text-field :model-value="scaleInputs.z" type="number" :max="50" :step="0.1" density="compact"
							hide-details variant="outlined" style="max-width: 80px; margin-left: 8px;"
							@update:model-value="(v) => onScaleInput('z', String(v))"></v-text-field>
					</div>
				</v-col>
			</v-row> -->

			<!-- Reset Buttons -->
			<v-row dense class="mt-3">
				<v-col cols="12">
					<v-btn block variant="outlined" size="small" @click="resetTransform">
						{{ $t("RESET_TRANSFORM") }}
					</v-btn>
				</v-col>
			</v-row>
		</v-card-text>
	</v-card>
</template>

<script>
import { ObjectType } from "@/models/objects/types";
import { roundRotation } from "./composables/useRotationTransform";
import {
	SIMPLE_STRUCTURE_EDIT_CONSTRAINTS,
	normalizeSpinnerInput,
} from "./composables/useSolidMeshEdit";

export default {
	name: "SolidMeshTransformPanelManual",
	props: {
		solidMeshId: String,
		isEditing: {
			type: Boolean,
			default: false,
		},
	},
	emits: ["transform-reset"],
	data() {
		return {
			rotation: { x: 0, y: 0, z: 0 },
			scale: { x: 1, y: 1, z: 1 },
			rotationInputs: { x: "0", y: "0", z: "0" },
			scaleInputs: { x: "1", y: "1", z: "1" },
			initialRotation: null,
			initialScale: null,
			isUpdating: false,
			pendingReload: false,
			currentSolidMeshId: null,
			transformReady: false,
		};
	},
	computed: {
		rotationConstraint() {
			return SIMPLE_STRUCTURE_EDIT_CONSTRAINTS.rotation;
		},
		solidMesh() {
			return this.$store.state.object.objects.find(
				(obj) =>
					obj.type === ObjectType.SOLID_MESH && obj.id === this.solidMeshId,
			);
		},
	},
	watch: {
		solidMesh: {
			async handler() {
				if (this.isUpdating) {
					this.pendingReload = true;
					return;
				}
				this.transformReady = false;
				const isNewObject =
					this.solidMesh && this.solidMesh.id !== this.currentSolidMeshId;
				const targetId = this.solidMesh?.id;
				if (isNewObject) {
					this.currentSolidMeshId = targetId;
				}
				await this.loadCurrentTransform();
				// Discard stale result if mesh changed during await
				if (this.solidMesh?.id !== targetId) return;
				if (isNewObject) {
					this.saveInitialValues();
				}
			},
			immediate: true,
		},
		rotationInputs: {
			handler() {
				this.updateTransformValidity();
			},
			deep: true,
		},
		scaleInputs: {
			handler() {
				this.updateTransformValidity();
			},
			deep: true,
		},
	},
	methods: {
		updateTransformValidity() {
			if (!this.isEditing) return;
			const hasInvalidRotation = Object.values(this.rotationInputs).some(
				(v) => {
					if (v === "") return true;
					const parsed = Number(v);
					return !Number.isFinite(parsed);
				},
			);
			const hasInvalidScale = Object.values(this.scaleInputs).some((v) => {
				if (v === "") return true;
				const parsed = Number(v);
				return !Number.isFinite(parsed);
			});
			this.$store.commit("object/setEditFormValidBySource", {
				source: "manual-transform",
				isValid: !(hasInvalidRotation || hasInvalidScale),
			});
		},

		syncRotationInputs() {
			this.rotationInputs = {
				x: String(this.rotation.x),
				y: String(this.rotation.y),
				z: String(this.rotation.z),
			};
		},

		syncScaleInputs() {
			this.scaleInputs = {
				x: String(this.scale.x),
				y: String(this.scale.y),
				z: String(this.scale.z),
			};
		},

		saveInitialValues() {
			if (!this.solidMesh?.metaData?.shapeConfig) return;
			const displayed =
				this.rotation &&
				(this.rotation.x !== undefined ||
					this.rotation.y !== undefined ||
					this.rotation.z !== undefined)
					? this.rotation
					: { x: 0, y: 0, z: 0 };
			this.initialRotation = roundRotation(displayed);
			const { scale } = this.solidMesh.metaData.shapeConfig;
			this.initialScale = {
				x: scale.x,
				y: scale.y,
				z: scale.z,
			};
			this.syncScaleInputs();
		},

		async loadCurrentTransform() {
			if (!this.solidMesh?.metaData?.shapeConfig) return;
			const storedRotation = this.solidMesh.metaData?.attributes?.rotation;
			const hasStoredRotation =
				storedRotation &&
				Number.isFinite(Number(storedRotation.x)) &&
				Number.isFinite(Number(storedRotation.y)) &&
				Number.isFinite(Number(storedRotation.z));
			let rotAngle = hasStoredRotation ? storedRotation : { x: 0, y: 0, z: 0 };
			try {
				this.isUpdating = true;
				this.transformReady = false;
				if (!hasStoredRotation) {
					const viewerRotation = await this.$store.dispatch(
						"solidMesh/getSolidMeshRotationDegrees",
						{ meshId: this.solidMesh.id, relativeToBaseline: true },
					);
					if (
						viewerRotation &&
						Number.isFinite(Number(viewerRotation.x)) &&
						Number.isFinite(Number(viewerRotation.y)) &&
						Number.isFinite(Number(viewerRotation.z))
					) {
						rotAngle = viewerRotation;
					}
				}
				this.rotation = {
					x: normalizeSpinnerInput(
						Number(rotAngle.x) || 0,
						this.rotationConstraint,
					),
					y: normalizeSpinnerInput(
						Number(rotAngle.y) || 0,
						this.rotationConstraint,
					),
					z: normalizeSpinnerInput(
						Number(rotAngle.z) || 0,
						this.rotationConstraint,
					),
				};
				this.syncRotationInputs();
			} catch (e) {
				this.rotation = {
					x: normalizeSpinnerInput(
						Number(rotAngle.x) || 0,
						this.rotationConstraint,
					),
					y: normalizeSpinnerInput(
						Number(rotAngle.y) || 0,
						this.rotationConstraint,
					),
					z: normalizeSpinnerInput(
						Number(rotAngle.z) || 0,
						this.rotationConstraint,
					),
				};
				this.syncRotationInputs();
				console.warn("Failed to load rotation:", e);
			} finally {
				// Re-read scale after await in case it changed
				const freshScale = this.solidMesh?.metaData?.shapeConfig?.scale;
				if (freshScale) {
					this.scale = { x: freshScale.x, y: freshScale.y, z: freshScale.z };
					this.syncScaleInputs();
				}
				this.$nextTick(() => {
					this.isUpdating = false;
					this.transformReady = true;
					if (this.pendingReload) {
						this.pendingReload = false;
						this.$options.watch.solidMesh.handler.call(this);
					}
				});
			}
		},

		onRotationUpdateForSlide(axis, value) {
			if (this.isUpdating || !this.solidMesh) return;
			this.isUpdating = true;
			const nextValue = normalizeSpinnerInput(
				Number(value),
				this.rotationConstraint,
			);
			this.rotation = { ...this.rotation, [axis]: nextValue };
			this.rotationInputs = {
				...this.rotationInputs,
				[axis]: String(nextValue),
			};
			this.solidMesh.setRotation(this.rotation);
			this.$nextTick(() => {
				this.isUpdating = false;
			});
		},

		onRotationEnd() {
			if (!this.solidMesh) return;
			this.isUpdating = true;
			this.solidMesh.setRotation(this.rotation);
			this.$nextTick(() => {
				this.isUpdating = false;
			});
		},

		onRotationChange(axis, value) {
			if (this.isUpdating || !this.solidMesh) return;
			this.isUpdating = true;
			const nextValue = normalizeSpinnerInput(
				Number(value),
				this.rotationConstraint,
			);
			this.rotation = { ...this.rotation, [axis]: nextValue };
			this.rotationInputs = {
				...this.rotationInputs,
				[axis]: String(nextValue),
			};
			this.solidMesh.setRotation(this.rotation);
			this.$nextTick(() => {
				this.isUpdating = false;
			});
		},

		onRotationUpdate(axis, value) {
			this.rotationInputs = { ...this.rotationInputs, [axis]: value };
			if (value === "") return;
			const parsed = Number(value);
			if (!Number.isFinite(parsed)) return;
			const normalized = normalizeSpinnerInput(parsed, this.rotationConstraint);
			this.rotationInputs = {
				...this.rotationInputs,
				[axis]: String(normalized),
			};
			value = normalized;
			this.onRotationChange(axis, normalized);
		},

		onRotationInput(axis, event) {
			const target = event.target;
			if (!target) return;
			if (target.value === "") {
				this.rotationInputs[axis] = undefined;
				return;
			}
			const parsed = target.valueAsNumber;
			if (!Number.isFinite(parsed)) return;
			const normalized = normalizeSpinnerInput(parsed, this.rotationConstraint);
			target.valueAsNumber = normalized;
			this.rotationInputs[axis] = normalized;
			this.onRotationUpdate(axis, normalized);
		},

		onScaleUpdate() {
			if (this.isUpdating || !this.solidMesh) return;
			const normalizedScale = this.applyScaleClamp();
			this.syncScaleInputs();
			this.isUpdating = true;
			this.solidMesh.setScale(normalizedScale);
			this.$nextTick(() => {
				this.isUpdating = false;
			});
		},

		onScaleEnd() {
			if (!this.solidMesh) return;
			this.isUpdating = true;
			const normalizedScale = this.applyScaleClamp();
			this.syncScaleInputs();
			this.solidMesh.setScale(normalizedScale);
			this.$nextTick(() => {
				this.isUpdating = false;
			});
		},

		onScaleChange() {
			if (this.isUpdating || !this.solidMesh) return;
			const normalizedScale = this.applyScaleClamp();
			this.syncScaleInputs();
			this.isUpdating = true;
			this.solidMesh.setScale(normalizedScale);
			this.$nextTick(() => {
				this.isUpdating = false;
			});
		},

		onScaleInput(axis, value) {
			this.scaleInputs = { ...this.scaleInputs, [axis]: value };
			if (value === "") return;
			const parsed = Number(value);
			if (!Number.isFinite(parsed)) return;
			this.scale = { ...this.scale, [axis]: parsed };
			this.onScaleChange();
		},

		resetTransform() {
			if (!this.initialRotation || !this.initialScale || !this.solidMesh)
				return;
			this.isUpdating = true;
			this.rotation = { ...this.initialRotation };
			this.scale = { ...this.initialScale };
			this.syncRotationInputs();
			this.syncScaleInputs();
			try {
				this.solidMesh.setRotation(this.rotation);
				const normalizedScale = this.applyScaleClamp();
				this.solidMesh.setScale(normalizedScale);
			} finally {
				this.$nextTick(() => {
					this.isUpdating = false;
					this.$emit("transform-reset", this.rotation);
				});
			}
		},

		applyScaleClamp() {
			const normalizedScale = {
				x: this.clampScaleValue(this.scale.x),
				y: this.clampScaleValue(this.scale.y),
				z: this.clampScaleValue(this.scale.z),
			};
			if (
				normalizedScale.x !== this.scale.x ||
				normalizedScale.y !== this.scale.y ||
				normalizedScale.z !== this.scale.z
			) {
				this.scale = { ...normalizedScale };
				this.syncScaleInputs();
			}
			return normalizedScale;
		},

		clampScaleValue(value) {
			if (!Number.isFinite(value)) return 0.1;
			const absValue = Math.abs(value);
			if (absValue < 0.1) return value < 0 ? -0.1 : 0.1;
			return value;
		},
	},
};
</script>

<style scoped>
.solid-mesh-transform-panel {
	margin-top: 8px;
}

.text-caption {
	color: rgba(255, 255, 255, 0.7);
	font-weight: 500;
}

.v-slider {
	flex-grow: 1;
}

.v-text-field :deep(.v-field) {
	font-size: 12px;
}

.v-text-field :deep(.v-field__input) {
	padding: 4px 8px;
	min-height: 28px;
}
</style>
